import React from "react";

import { IgTabPanel } from "@intelligems/ig-theme";
import { Grid, Tab, Tabs } from "@mui/material";

import theme from "../../../theme";
import { WidgetsTabWrapper } from "../WidgetsTabWrapper";

import { LibraryTabsProps } from "./types";

export const TestTabs = ({ tabValue, onChange }: LibraryTabsProps) => {
  return (
    <>
      <Grid container direction={"row"} alignItems={"center"} columnSpacing={1}>
        <Grid flex={1} item>
          <Tabs
            centered={true}
            value={tabValue}
            onChange={onChange}
            aria-label={`Test Tabs`}
            sx={{
              borderBottom: 1,
              borderColor: theme.palette.gray.light,
              marginBottom: "20px",
            }}
          >
            <Tab sx={{ textTransform: "none" }} label="Shipping Progress Bar" />
          </Tabs>
        </Grid>
      </Grid>
      <IgTabPanel value={tabValue} index={0}>
        <WidgetsTabWrapper widgetType={"shippingProgressBar"} />
      </IgTabPanel>
    </>
  );
};
